import React from 'react';
import { AdBannerPlaceholder } from 'shared/components/AdBannerPlaceholder';
import { AdfoxBanner } from 'shared/components/AdfoxBanner';
import { OFFER_CARD_DESKTOP_CARD_ADFOX_PLACEMENTS } from 'shared/constants/adfoxPlacements';
import { AdBannerMicrofrontend } from 'shared/containers/AdBannerMicrofrontend';
import { AdfoxContextProvider } from 'shared/context/AdfoxContext';
import { useAdBannerMicrofrontendEnabled } from 'shared/utils/adfox';

const PLACEMENT = OFFER_CARD_DESKTOP_CARD_ADFOX_PLACEMENTS.aside;

export const TgbAsideBannerContainer: React.FC = () => {
  const isMicrofrontendEnabled = useAdBannerMicrofrontendEnabled();

  return (
    <AdfoxContextProvider
      bannerPlace={PLACEMENT.bannerPlace}
      postViewAnalyticsData={PLACEMENT.postViewAnalyticsData}
      size={PLACEMENT.sizes}
      pParams={PLACEMENT.pParams}
    >
      {isMicrofrontendEnabled ? (
        <AdBannerPlaceholder sizes={PLACEMENT.sizes} testId="AdBannerAside">
          <AdBannerMicrofrontend />
        </AdBannerPlaceholder>
      ) : (
        <AdfoxBanner />
      )}
    </AdfoxContextProvider>
  );
};
